<template>
  <div id="index">
    <div
      id="header"
      :style="screenWidth < 1200 ? 'opacity: 0;display:none' : 'opacity: 1;'"
    >
      <router-link
        :to="userType == 'zfyh' || userType == 'gly' ? '/home' : '/index'"
      >
        <div class="title">
          <img src="../../assets/imgs/icon/icon_computer.png" alt />
          工业经济监测平台
        </div>
      </router-link>
      <div class="menuBox">
        <el-menu
          :default-active="currentIndex"
          class="el-menu-demo headMenu"
          mode="horizontal"
          background-color="#2e323f"
          text-color="rgba(255,255,255,.8)"
          active-text-color="#5584FF"
          style="height: 100%"
          router
        >
          <el-menu-item
            :index="item.path"
            v-for="(item, i) in menuList"
            :key="i + 'a'"
            >{{ item.title }}</el-menu-item
          >
        </el-menu>
      </div>
      <div class="rightShare">
        <el-menu
          class="el-menu-demo rightMenu"
          mode="horizontal"
          background-color="#2e323f"
          text-color="rgba(255,255,255,.8)"
          active-text-color="#5584FF"
          style="
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: flex-end;
          "
          menu-trigger="click"
        >
          <el-menu-item
            index="/sinDisplay"
            @click.native="toDis"
            v-if="screen == 't'"
          >
            <i class="el-icon-s-platform"></i>
            <span>大屏</span>
          </el-menu-item>
          <el-submenu index="2" popper-class="submenupopper">
            <template slot="title">
              <span>{{ loginName }}</span>
            </template>
            <el-menu-item index="2-2" title="点击退出" @click="sginOut"
              >安全退出</el-menu-item
            >
            <el-menu-item index="2-2" title="点击下载">
              <a
                :href="`api/business/file/download/${manualId}`"
                style="color: rgba(255, 255, 255, 0.8); font-size: 14px"
                >操作手册</a
              >
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div
      id="header_phone"
      :style="screenWidth >= 1200 ? 'opacity: 0;display:none' : 'opacity: 1;'"
    >
      <router-link
        :to="userType == 'zfyh' || userType == 'gly' ? '/home' : '/index'"
      >
        <div class="title">
          <img src="../../assets/imgs/icon/icon_computer.png" alt />
          工业经济监测平台
        </div>
      </router-link>
      <div class="sign_out">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-user"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <span @click="sginOut"
              ><el-dropdown-item>安全退出 </el-dropdown-item></span
            >
            <a
              :href="`api/business/file/download/${manualId}`"
              style="color: rgba(255, 255, 255, 0.8); font-size: 14px"
              ><el-dropdown-item>操作手册</el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="hamburger" @click="drawer = true">
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <el-drawer
        title="工业经济监测平台"
        :modal-append-to-body="false"
        :visible.sync="drawer"
        direction="ttb"
        size="auto"
      >
        <template slot="title">
          <router-link
            :to="userType == 'zfyh' || userType == 'gly' ? '/home' : '/index'"
          >
            <div class="title">
              <img src="../../assets/imgs/icon/icon_computer.png" alt />
              工业经济监测平台
            </div></router-link
          >
        </template>

        <el-menu
          @open="handleOpen"
          @close="handleClose"
          :default-active="currentIndex"
          class="el-menu-vertical-demo"
          background-color="#2e323f"
          text-color="rgba(255,255,255,.8)"
          active-text-color="#5584FF"
          router
        >
          <el-submenu
            :index="item.path"
            v-for="(item, j) in menuList"
            :key="j + 'b'"
            v-show="item.isPhone == 1"
          >
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item-group
              v-for="(item_child, n) in item.children"
              :key="n + 'e'"
              v-show="
                item_child.children.length == 0 && item_child.isPhone == 1
              "
            >
              <el-menu-item @click="drawer = false" :index="item_child.path"
                ><i class="el-icon-location"></i
                >{{ item_child.title }}</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group
              v-for="(item_child, m) in item.children"
              :key="m + 'c'"
              v-show="
                item_child.children.length != 0 && item_child.isPhone == 1
              "
            >
              <el-submenu :index="item_child.path">
                <template slot="title"
                  ><i class="el-icon-menu"></i>
                  <span>{{ item_child.title }}</span></template
                >
                <el-menu-item
                  @click="drawer = false"
                  :index="item_child_nod.path"
                  v-for="(item_child_nod, k) in item_child.children"
                  :key="k + 'd'"
                  v-show="item_child_nod.isPhone == 1"
                  ><i class="el-icon-location"></i
                  >{{ item_child_nod.title }}</el-menu-item
                >
              </el-submenu>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
        <div style="background: #2e323f; height: 30px"></div>
      </el-drawer>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      drawer: false,
      activeNames: ["1"],
      screen: "f",
      loginName: "",
      manualId: "",
      currentIndex: "/index/workbench",
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
    };
  },
  components: {},
  created() {
    this.$axios.get(`/system/user/selectNowUserName`).then((res) => {
      this.loginName = res.data;
    });
    // this.loginName = sessionStorage.getItem("loginName");
    this.downloadManual();
  },
  watch: {
    $route: {
      //监控路由参数的变化
      handler(n) {
        this.currentIndex = n.matched[1].path;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.screen = sessionStorage.getItem("screen");
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    console.log("----------", this.menuList);
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleChange(val) {
      console.log(val);
    },
    toDis() {
      this.$router.push("/newScreen");
    },
    sginOut() {
      console.log(123232);
      this.$axios
        .get(`system/config/selectConfigByKey?key=sso.logout`)
        .then((result) => {
          console.log(result.data.data[0].value);
          window.location = result.data.data[0].value;
        });
    },
    downloadManual() {
      this.$axios.get("/system/desktop/downloadManual").then((res) => {
        this.manualId = res.data;
      });
    },
  },
  computed: {
    ...mapGetters({
      menuList: "getMenuTreeIndex",
    }),
    userType() {
      return sessionStorage.getItem("userType");
    },
  },
};
</script>
<style>
.el-drawer__header {
  width: 95% !important;
  border-bottom: 1px solid #a0a0a0;
  padding: 20px 20px 10px 0 !important;
  background: #2e323f;
  margin-bottom: 0px !important;
  position: fixed !important;
  top: 0 !important;
  z-index: 9999;
}
.el-menu {
  border-right: 0 !important;
}
/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__wrapper {
  overflow: auto !important;
}
.el-drawer__body {
  margin-top: 60px;
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}
</style>

<style lang="less" scoped>
#index {
  height: 100%;
}

#header_phone {
  position: fixed;
  min-width: 1366px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999999;
  height: 60px;
  background-color: #2e323f;
  display: flex;

  .title {
    height: 100%;
    width: 248px;
    display: flex;
    align-items: center;
    color: #fff;

    img {
      margin-left: 31px;
      width: 18px;
      height: 16px;
      margin-right: 12px;
    }
  }

  .menuBox {
    height: 100%;
    flex: 1;
  }

  .rightShare {
    height: 100%;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

#header {
  position: fixed;
  min-width: 1366px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1999;
  height: 75px;
  background-color: #2e323f;
  display: flex;

  .title {
    height: 100%;
    width: 248px;
    display: flex;
    align-items: center;
    color: #fff;
    box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);

    img {
      margin-left: 31px;
      width: 18px;
      height: 16px;
      margin-right: 12px;
    }
  }
  .menuBox {
    height: 100%;
    flex: 1;
  }

  .rightShare {
    height: 100%;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.main {
  height: 100%;
  overflow: auto;
}

.main::-webkit-scrollbar {
  display: none;
}

.hamburger .line {
  width: 26px;
  height: 2px;
  background-color: #606266;
  display: block;
  margin: 6px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.hamburger {
  position: fixed;
  right: 20px;
  top: 15px;
}

.sign_out {
  position: fixed;
  right: 66px;
  top: 17px;
  color: #606266;
}
.sign_out i {
  font-size: 26px;
}
</style>